import {
  doc,
  setDoc,
  serverTimestamp,
  collection,
  query,
  updateDoc,
  where,
  increment,
  getDocs
} from "firebase/firestore";

import { dbstatus } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const create_comment = async (data) => {
  const { message, contentid } = data || {};

  // ================= VALIDATION =================
  if (!contentid || !contentid.trim()) {
    return { success: false, error: "Missing contentid" };
  }

  if (!message || !message.trim()) {
    return { success: false, error: "Missing message" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const tablename = "statusmessage";

    // ================= LIMIT CHECK (MAX 5) =================
    const commentsRef = collection(
      dbstatus,
      tablename,
      contentid,
      "comments"
    );

    const q = query(commentsRef, where("guid", "==", guid));
    const snapshot = await getDocs(q);

    if (snapshot.size >= 5) {
      return {
        success: false,
        error: "You can only add maximum 5 comments"
      };
    }

    // ================= USER DATA =================
    const usercity = Cookies.get("city") || "Unknown";
    const userpostcode = Cookies.get("postcode") || "000000";
    const userstate = Cookies.get("state") || "N/A";
    const usercountryname = Cookies.get("country") || "N/A";
    const userlatitude = Cookies.get("latitude") || "0";
    const userlongitude = Cookies.get("longitude") || "0";
    const useraddress = Cookies.get("address") || "Not Available";

    const commtuid = Randomcode(8);

    const docRef = doc(
      dbstatus,
      tablename,
      contentid,
      "comments",
      commtuid
    );

    await setDoc(
      docRef,
      {
        ...data,
        contentid,
        guid,
        indexnumber: 0,
        sessiontoken,
        like: 0,
        read: 0,
        download: 0,
        copy: 0,
        commtuid,
        comment: 0,
        share: 0,
        city: usercity,
        postcode: userpostcode,
        state: userstate,
        country: usercountryname,
        address: useraddress,
        latitude: userlatitude,
        longitude: userlongitude,
        status: true,
        date_time: Date.now(),
      },
      { merge: true }
    );


        const comdocRef = doc(dbstatus, tablename, contentid);
    
        // increase counter
        await updateDoc(comdocRef, {
         comment: increment(1)
        });
    return { success: true };

  } catch (err) {
    console.error("❌ Create_comment_error:", err);

    return {
      success: false,
      error: err.message || "Firestore operation failed"
    };
  }
};